// App.jsx
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import { SplashScreen } from '@capacitor/splash-screen';
import { I18nProvider } from './i18n';
import GovSky from './components/GovSky';
import SinglePost from './components/SinglePost';
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  useEffect(() => {
    // Initialize Capacitor plugins for native platforms
    const initCapacitor = async () => {
      if (Capacitor.isNativePlatform()) {
        try {
          // Configure status bar for iOS
          if (Capacitor.getPlatform() === 'ios') {
            // Detect system dark mode preference
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            
            // Set status bar style based on system preference
            // Style.Dark = dark text (for light backgrounds)
            // Style.Light = light text (for dark backgrounds)
            await StatusBar.setStyle({ 
              style: prefersDark ? Style.Light : Style.Dark 
            });
            
            // Don't overlay - let iOS handle the status bar area with native background color
            await StatusBar.setOverlaysWebView({ overlay: false });

            // Listen for system dark mode changes
            window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', async (e) => {
              try {
                await StatusBar.setStyle({ 
                  style: e.matches ? Style.Light : Style.Dark 
                });
              } catch (err) {
                // Status bar update failed
              }
            });
          }

          // Configure keyboard behavior
          Keyboard.setAccessoryBarVisible({ isVisible: true });
          Keyboard.setScroll({ isDisabled: false });

          // Hide splash screen after app is ready
          await SplashScreen.hide();
        } catch (error) {
          // Capacitor plugin initialization error (non-critical)
        }
      }
    };

    initCapacitor();
  }, []);

  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GovSky />} />
          <Route path="/post/:handle/:id" element={<SinglePost />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          {/* Catch all route - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
